import * as Styled from '../styled'
import { PaperAirplane, Button } from '~components'
import { useNavigate } from '~hooks'

function ResponseError() {
  const navigate = useNavigate()

  function handleClick() {
    navigate('/entrar', { state: { previousPath: '/erro/envio-dados' }})
  }

  return (
    <Styled.Wrapper role="region">
      <PaperAirplane />
      <Styled.Title>Erro no envio dos dados</Styled.Title>
      <Styled.Description>
        Ocorreu um problema de comunicação com nosso servidor para o envio dos dados.
      </Styled.Description>
      <Button onClick={handleClick}>Tentar novamente mais tarde</Button>
    </Styled.Wrapper>
  )
}

export default ResponseError
